import script from "./MainCanvasEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./MainCanvasEditor.vue?vue&type=script&setup=true&lang=js"

import "./MainCanvasEditor.vue?vue&type=style&index=0&id=01debd90&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01debd90"]])

export default __exports__